'use client';

import Shelf from 'components/containers/shelf';
import styles from './section-navigation.module.scss';
import { useEffect, useState } from 'react';
import { useTranslations } from 'next-intl';

/*
	This component searches the DOM for  <section> elements that are direct children of <main>.
	Then uses the text from the first h1,h2,h3,h4 or h5 element as the link text.

	It has a major downside of needing a rendered DOM to generate it's links but
	the major upside of being very generic and usable on any page with minimal refactoring.

	Not 100% sure if I love this component, but its a useful, though heavyhanded, tool for our toolbox
*/

interface IProps {
	allowedHTags?: string;
}

const SectionNavigation = ({ allowedHTags = 'h1,h2,h3,h4,h5' }: IProps) => {
	const t = useTranslations();
	const [sectionsWithTitle, setSectionsWithTitle] = useState([]);

	const handleClick = (section) => {
		section.node?.scrollIntoView({ behavior: 'smooth' });
	};

	/* eslint-disable react-hooks/set-state-in-effect -- TODO: let's fix this so that we're not setting state in useEffect. */
	useEffect(() => {
		const sections = document.querySelectorAll('main > section'); //DOM list of all sections on the page.

		sections &&
			setSectionsWithTitle(
				[...sections]?.map((section) => {
					return {
						node: section,
						firstTitle: section.querySelector(allowedHTags)?.textContent,
					};
				}),
			); //Array of all sections + the text of their first `h` element.
	}, [allowedHTags]);
	/* eslint-enable react-hooks/set-state-in-effect */

	const titles = sectionsWithTitle.filter((section) => !!section.firstTitle);
	return (
		<nav className={styles.nav}>
			<Shelf gap="var(--spacing-xs)">
				<span className={styles.jumpText}>{t('jumpTo')}:</span>
				{titles?.map((section) => {
					return (
						<span key={section.firstTitle}>
							<button
								className={styles.link}
								onClick={() => handleClick(section)}
							>
								{section.firstTitle}
							</button>
						</span>
					);
				})}
			</Shelf>
		</nav>
	);
};

export default SectionNavigation;
